import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AdaptDateModule } from "@common/ux/date/date.module";
import { AdaptEditorViewModule } from "@common/ux/html-editor/editor-view.module";
import { DxPopoverModule } from "devextreme-angular";
import { ActivityRescheduledInfoComponent } from "./activity-rescheduled-info/activity-rescheduled-info.component";


@NgModule({
    declarations: [
        ActivityRescheduledInfoComponent,
    ],
    exports: [
        ActivityRescheduledInfoComponent,
    ],
    imports: [
        CommonModule,
        AdaptDateModule,
        DxPopoverModule,
        AdaptEditorViewModule,
    ],
})
export class AdaptActivitiesSharedModule {}
